/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationCapacities200ResponseOneOf1FloorplansInner
 */
export interface GetReservationCapacities200ResponseOneOf1FloorplansInner {
    /**
     * 
     * @type {string}
     * @memberof GetReservationCapacities200ResponseOneOf1FloorplansInner
     */
    floorplanId: string;
    /**
     * 
     * @type {number}
     * @memberof GetReservationCapacities200ResponseOneOf1FloorplansInner
     */
    size: number;
    /**
     * 
     * @type {string}
     * @memberof GetReservationCapacities200ResponseOneOf1FloorplansInner
     */
    sizeType: GetReservationCapacities200ResponseOneOf1FloorplansInnerSizeTypeEnum;
}


/**
 * @export
 */
export const GetReservationCapacities200ResponseOneOf1FloorplansInnerSizeTypeEnum = {
    Percentage: 'percentage',
    People: 'people'
} as const;
export type GetReservationCapacities200ResponseOneOf1FloorplansInnerSizeTypeEnum = typeof GetReservationCapacities200ResponseOneOf1FloorplansInnerSizeTypeEnum[keyof typeof GetReservationCapacities200ResponseOneOf1FloorplansInnerSizeTypeEnum];


/**
 * Check if a given object implements the GetReservationCapacities200ResponseOneOf1FloorplansInner interface.
 */
export function instanceOfGetReservationCapacities200ResponseOneOf1FloorplansInner(value: object): value is GetReservationCapacities200ResponseOneOf1FloorplansInner {
    if (!('floorplanId' in value) || value['floorplanId'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('sizeType' in value) || value['sizeType'] === undefined) return false;
    return true;
}

export function GetReservationCapacities200ResponseOneOf1FloorplansInnerFromJSON(json: any): GetReservationCapacities200ResponseOneOf1FloorplansInner {
    return GetReservationCapacities200ResponseOneOf1FloorplansInnerFromJSONTyped(json, false);
}

export function GetReservationCapacities200ResponseOneOf1FloorplansInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationCapacities200ResponseOneOf1FloorplansInner {
    if (json == null) {
        return json;
    }
    return {
        
        'floorplanId': json['floorplanId'],
        'size': json['size'],
        'sizeType': json['sizeType'],
    };
}

export function GetReservationCapacities200ResponseOneOf1FloorplansInnerToJSON(json: any): GetReservationCapacities200ResponseOneOf1FloorplansInner {
    return GetReservationCapacities200ResponseOneOf1FloorplansInnerToJSONTyped(json, false);
}

export function GetReservationCapacities200ResponseOneOf1FloorplansInnerToJSONTyped(value?: GetReservationCapacities200ResponseOneOf1FloorplansInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'floorplanId': value['floorplanId'],
        'size': value['size'],
        'sizeType': value['sizeType'],
    };
}

